module.exports = __webpack_public_path__ + "static/media/btn-piece-collection-deco.8c1f3c75.png";